export const allIndexesInString = (input: string, search: string) => {
  let lastIndex = -1;
  const indexes: number[] = [];
  do {
    lastIndex = input.indexOf(search, lastIndex + 1);
    if (lastIndex !== -1) indexes.push(lastIndex);
  } while(lastIndex > -1);
  return indexes;
}